module.exports = __webpack_public_path__ + "img/16.21caf856.svg";